import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Cookies from 'universal-cookie';

/**
 * Redux state for tracked cookies
 */
export interface CookiesState {
  [key: string]: string | undefined;
}

// Action Types
export const SET_COOKIE = 'cookies/SET_COOKIE';
export const REMOVE_COOKIE = 'cookies/REMOVE_COOKIE';

interface SetCookieAction {
  type: typeof SET_COOKIE;
  payload: {
    key: string;
    value: string;
  };
}

interface RemoveCookieAction {
  type: typeof REMOVE_COOKIE;
  payload: string;
}

export type CookiesActionTypes = SetCookieAction | RemoveCookieAction;

// Action Creators
const setCookieAction = (key: string, value: string): SetCookieAction => ({
  type: SET_COOKIE,
  payload: { key, value },
});

const removeCookieAction = (key: string): RemoveCookieAction => ({
  type: REMOVE_COOKIE,
  payload: key,
});

// Thunk Action Creators
export const setCookie = (
  key: string,
  value: string,
  options: any = { path: '/' },
): ThunkAction<void, any, unknown, Action<string>> => {
  return (dispatch) => {
    const cookies = new Cookies();
    cookies.set(key, value, options);
    dispatch(setCookieAction(key, value));
  };
};

export const removeCookie = (
  key: string,
  options: any = { path: '/' },
): ThunkAction<void, any, unknown, Action<string>> => {
  return (dispatch) => {
    const cookies = new Cookies();
    cookies.remove(key, options);
    dispatch(removeCookieAction(key));
  };
};

// Initial State
const initialState: CookiesState = {};

// Reducer
export default function cookiesReducer(state: CookiesState = initialState, action: CookiesActionTypes): CookiesState {
  switch (action.type) {
    case SET_COOKIE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case REMOVE_COOKIE:
      const newState = { ...state };
      delete newState[action.payload];
      return newState;

    default:
      return state;
  }
}
